import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cookie } from 'lucide-react';

const CookiePolicy = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-primary)',
      padding: '40px 24px'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto'
      }}>
        {/* Back Link */}
        <Link to="/" style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          color: 'var(--accent-gold)',
          textDecoration: 'none',
          marginBottom: '32px',
          fontSize: '14px'
        }}>
          <ArrowLeft size={16} />
          Back to Home
        </Link>

        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          marginBottom: '40px'
        }}>
          <div style={{
            width: '56px',
            height: '56px',
            borderRadius: '12px',
            background: 'rgba(212, 175, 55, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Cookie size={28} color="var(--accent-gold)" />
          </div>
          <div>
            <h1 style={{
              fontSize: '32px',
              fontWeight: 700,
              color: 'var(--text-primary)',
              marginBottom: '4px'
            }}>Cookie Policy</h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>
              Last updated: January 2026
            </p>
          </div>
        </div>

        {/* Content */}
        <div style={{
          background: 'var(--bg-secondary)',
          borderRadius: '16px',
          border: '1px solid var(--border-subtle)',
          padding: '40px'
        }}>
          <div style={{ color: 'var(--text-secondary)', lineHeight: 1.8, fontSize: '15px' }}>
            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                1. What Are Cookies?
              </h2>
              <p>
                Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and provide information to the owners of the site. Cookies help us enhance your experience on our platform and remember your preferences.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                2. Types of Cookies We Use
              </h2>
              
              <h3 style={{ color: 'var(--text-primary)', fontSize: '16px', fontWeight: 600, marginBottom: '12px', marginTop: '20px' }}>
                Essential Cookies
              </h3>
              <p style={{ marginBottom: '16px' }}>
                These cookies are necessary for the website to function properly. They enable core functionality such as security, network management, and account access. You cannot opt out of these cookies.
              </p>

              <h3 style={{ color: 'var(--text-primary)', fontSize: '16px', fontWeight: 600, marginBottom: '12px' }}>
                Performance Cookies
              </h3>
              <p style={{ marginBottom: '16px' }}>
                These cookies collect information about how visitors use our website, such as which pages are visited most often. This data helps us improve how our website works.
              </p>

              <h3 style={{ color: 'var(--text-primary)', fontSize: '16px', fontWeight: 600, marginBottom: '12px' }}>
                Functionality Cookies
              </h3>
              <p style={{ marginBottom: '16px' }}>
                These cookies allow the website to remember choices you make (such as your language preference) and provide enhanced, personalized features.
              </p>

              <h3 style={{ color: 'var(--text-primary)', fontSize: '16px', fontWeight: 600, marginBottom: '12px' }}>
                Analytics Cookies
              </h3>
              <p>
                We use analytics cookies to understand how visitors interact with our website. This helps us improve our services and user experience.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                3. Third-Party Cookies
              </h2>
              <p style={{ marginBottom: '12px' }}>
                Some cookies are placed by third-party services that appear on our pages:
              </p>
              <ul style={{ marginLeft: '24px' }}>
                <li style={{ marginBottom: '8px' }}><strong>Tawk.to:</strong> Our live chat service uses cookies to maintain chat sessions and improve support services.</li>
                <li style={{ marginBottom: '8px' }}><strong>Payment Processors:</strong> Our payment partners may use cookies to process transactions securely.</li>
                <li style={{ marginBottom: '8px' }}><strong>Analytics Services:</strong> We may use third-party analytics to understand website usage patterns.</li>
              </ul>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                4. How to Control Cookies
              </h2>
              <p style={{ marginBottom: '12px' }}>
                You can control and manage cookies in various ways:
              </p>
              <ul style={{ marginLeft: '24px' }}>
                <li style={{ marginBottom: '8px' }}><strong>Browser Settings:</strong> Most browsers allow you to refuse or delete cookies through their settings.</li>
                <li style={{ marginBottom: '8px' }}><strong>Third-Party Tools:</strong> Various online tools allow you to opt out of specific tracking cookies.</li>
              </ul>
              <p style={{ marginTop: '12px' }}>
                Please note that disabling cookies may affect the functionality of our website and your ability to use certain features.
              </p>
            </section>

            <section style={{ marginBottom: '32px' }}>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                5. Cookie Retention
              </h2>
              <p>
                Different cookies have different retention periods. Session cookies are deleted when you close your browser, while persistent cookies remain on your device for a set period or until you delete them manually. Our essential cookies typically last for the duration of your session, while preference cookies may last up to 12 months.
              </p>
            </section>

            <section>
              <h2 style={{ color: 'var(--text-primary)', fontSize: '20px', fontWeight: 600, marginBottom: '16px' }}>
                6. Updates to This Policy
              </h2>
              <p>
                We may update this Cookie Policy from time to time to reflect changes in technology, legislation, or our data practices. When we make changes, we will update the "Last updated" date at the top of this policy. We encourage you to review this policy periodically.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
